module.exports = __webpack_public_path__ + "img/capusta-logo-colored-special-compressed.69ec0da2.svg";